<script setup>


</script>

<template>
  <div class="tl-footer">
    <div class="footer-content bg-image" style="background-image: url(/static/image/footer.jpg);">
      <div class="container">
        <div class="footer-top">
          <div class="newsletter justify-content-between">

          </div>
        </div><!-- /.footer-top -->

        <div class="footer-middle">
          <div class="row">
            <div class="col-md-8 col-lg-4">
              <div class="footer-widget">
                <div class="footer-logo" style="display: flex; justify-content: center">
                  <img src="/static/picture/logo1.png" alt="Logo" class="img-fluid" style="width: 50%; height: 50%;">
                </div>
                <p>Dongxia Doors and Windows Company always adheres to the corporate philosophy
                  of "reputation first, customer first", and constantly innovates in accordance
                  with domestic requirements for home environments.</p>
                <span class="phone-number"><a href="tel:+8613923140282"> <span class="mr-2 fa fa-phone"></span>+86 13923140282</a></span>
              </div><!-- /.footer-widget -->
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="footer-widget">

              </div><!-- /.footer-widget -->
            </div>
            <div class="col-md-8 col-lg-3">
              <div class="footer-widget">
                <h3>Navigation</h3>
                <ul class="global-list">
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/products">Products</a></li>
                  <li><a href="/blogs">Blogs</a></li>
                  <li><a href="/contact">Contact</a></li>
                </ul>
              </div><!-- /.footer-widget -->
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="footer-widget">
                <h3>Products category</h3>
                <ul class="global-list">
                  <li><a href="/products/?category_id_category=Aluminum Window">Aluminum Window</a></li>
                  <li><a href="/products/?category_id_category=Aluminum Door">Aluminum Door</a></li>
                  <li><a href="/products/?category_id_category=Sunroom">Sunromm</a></li>
                </ul>
              </div><!-- /.footer-widget -->
            </div>
          </div><!-- /.row -->
        </div><!-- /.footer-middle -->

        <div class="footer-bottom clearfix">
          <div class="d-flex justify-content-between">
            <div class="left-content">
              <span>Copyright &copy; Dongxia Aluminum Window & Door Co., Ltd All Rights Reserved.</span>
            </div>
            <div class="right-content">
              <ul class="global-list d-flex">
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
          </div>
        </div><!-- /.footer-bottom -->
      </div><!-- /.container -->
    </div><!-- /.footer-content -->
  </div><!-- /.tl-footer -->

  <div class="float-service-bar">
    <ul>
      <li class="phone-service">
        <a href="https://api.whatsapp.com/send?phone=8613923140282" target="_blank">
          <i class="fa fa-whatsapp"></i>
        </a>
        <div class="phone-popup">
          <img src='/static/picture/whatsapp-dongxia.png' alt="111" class="qrcode-img">
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
/* 悬浮客服栏样式 */
.float-service-bar {
  position: fixed;
  right: 20px;
  bottom: 250px;
  z-index: 9999;
}

.float-service-bar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.float-service-bar li {
  width: 50px;
  height: 50px;
  background: #fff;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  text-align: center;
  position: relative;
  transition: all 0.3s;
}

.float-service-bar li:hover {
  transform: translateX(-10px);
  background: #f8f8f8;
}

.float-service-bar a {
  color: #666;
  display: block;
  height: 100%;
  line-height: 50px;
  text-decoration: none;
}

.float-service-bar i {
  font-size: 24px;
}

/* 悬浮提示样式 */

.phone-popup {
  position: absolute;
  right: 100%; /* 改为向左弹出 */
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  opacity: 0; /* 初始隐藏 */
  visibility: hidden; /* 更安全的隐藏方式 */
  transition: all 0.3s ease;
  width: 180px; /* 给固定宽度 */
}

.qrcode-img {
  width: 100% !important; /* 覆盖行内样式 */
  height: auto;
  display: block;
  border: 1px solid #eee;
  border-radius: 4px;
}

.phone-service:hover .phone-popup {
  opacity: 1;
  visibility: visible;
  right: calc(100% + 20px); /* 向右偏移留出间距 */
}
</style>